export default {
  meetings: 'meetings',
  meetingTemplates: 'meetingTemplates',
  secure: 'secure',
  transaction: 'transaction',
  missionControl: 'missionControl',
  notes: 'notes',
  goals: 'goals',
  cashflow: 'cashFlow',
  transactions: 'transactions',
  transactionSummary: 'transactionSummary',
  personalEmailTemplates: 'personalEmailTemplates',
  emergencyFund: 'emergencyFund',
  accountManagement: 'accountManagement',
  messages: 'messages',
  sharedNextBestNextSteps: 'sharedNextBestNextSteps',
  accountLinkingEvents: 'accountLinkingEvents',
  accounts: 'accounts',
  noteTemplates: 'noteTemplates',
  actionItems: 'actionItems',
  attachments: 'attachments',
  householdBalances: 'householdBalances',
  missionControlEditableSequenceItem: 'missionControlEditableSequenceItem',
  simpleActionItems: 'simpleActionItems',
  default: 'default',
  goalsPageAndBanner: 'goalsPageAndBanner',
  newClientNavigation: 'newClientNavigation',
  budget: 'budget',
  timelineRefresh: 'timelineRefresh',
  cashflowExperimental: 'cashflowExperimental',
  newClientDashboard: 'newClientDashboard',
  todayDashboard: 'todayDashboard',
  realAssets: 'realAssets',
  playbooks: 'playbooks',
  cashFlowTrends: 'cashFlowTrends',
  trendTransactions: 'trendTransactions',
  notesContextMenu: 'notesContextMenu',
  bestNextStepChecklist: 'bestNextStepChecklist',
  bestNextSteps: 'bestNextSteps',
  workspaces: 'workspaces',
  householdBalancesByAccountType: 'householdBalancesByAccountType',
  goalFlowToggle: 'flow',
  data: 'data',
  clientMeetingPreview: 'clientMeetingPreview',
  activityFeed: 'activityFeed',
  portfolio: 'portfolio',
  holdings: 'holdings',
  images: 'images',
  clientsWithDependents: 'clientsWithDependents',
  meetingSummary: 'meetingSummary',
  addOnService: 'addOnService',
  achTransfers: 'achTransfers',
  apexRefreshEvents: 'apexRefreshEvents',
  apexRefreshAccountFundingEvents: 'apexRefreshAccountFundingEvents',
  facetPlanAssumptions: 'facetPlanAssumptions',
};

// NOTE: This file should no longer be maintained. Instead add new relationships to facet-rest/src/consts/relationships.js
//       If we add relationships there then they will also be available in other projects like apipuncher.
